import api from './index';
import { withRuntimeUrl } from './runtimeConfig';
import { UserGuideConfig } from 'features/userGuide/types';

type UploadGuideMediaRequest = {
  file: File;
};

type UploadGuideMediaResponse = {
  key: string;
  path: string;
  fileName: string;
  name: string;
  contentType?: string;
  uploadedAt?: string;
  uploadedBy?: {
    id: string;
    email?: string;
    name: string;
  };
  type?: 'image' | 'video';
};

const withCreativeServerUrl = (buildRequest: (arg: any) => any) =>
  withRuntimeUrl(
    'creativeServerUrl',
    'Creative server URL not configured in ETCD',
    buildRequest,
  );

const userGuideApi = api.injectEndpoints({
  endpoints: build => ({
    getUserGuide: build.query<UserGuideConfig, void>({
      queryFn: withCreativeServerUrl(() => ({
        method: 'GET',
        url: '/v1/on-demand/user-guide',
      })),
      providesTags: () => [{ type: 'userGuide', id: 'CONFIG' }],
    }),
    updateUserGuide: build.mutation<UserGuideConfig, UserGuideConfig>({
      queryFn: withCreativeServerUrl((body: UserGuideConfig) => ({
        method: 'PUT',
        url: '/v1/on-demand/user-guide',
        headers: {
          'Content-Type': 'application/json',
        },
        body,
      })),
      invalidatesTags: () => [{ type: 'userGuide', id: 'CONFIG' }],
    }),
    uploadUserGuideMedia: build.mutation<
      UploadGuideMediaResponse,
      UploadGuideMediaRequest
    >({
      queryFn: withCreativeServerUrl(({ file }) => {
        const formData = new FormData();
        formData.append('file', file);

        return {
          method: 'POST',
          url: '/v1/on-demand/user-guide/media',
          body: formData,
        };
      }),
    }),
  }),
});

export const {
  useGetUserGuideQuery,
  useUpdateUserGuideMutation,
  useUploadUserGuideMediaMutation,
} = userGuideApi;
